import React from 'react'
import { Container } from 'react-bootstrap'
import './TeacherIntroduction.css'
import teacher from '../../Assets/images/teacher.jpg'
import { Link } from 'react-router-dom'
export default function TeacherIntroduction() {
    return (
        <div className='teacher-introduction'>
            <Container>
                <div className='teacher-introduction-wrapper'>
                    <div className='teacher-introduction-right'>
                        <h1>بهترین استادان ایرانی در یک پلتفرم</h1>
                        <h3>
                            .یک آموزش جامع صنعت نیازمند استادی است که تجربه و علم تولید محصول ، مدیرت کارخانه و تدریس در دانشگاه و موسسات آموزشی را داشته باشد
                        </h3>
                        <Link to='/aboutus'>
                            <button>بیشتر درباره ما بدانید</button>
                        </Link>

                    </div>
                    <div className='teacher-introduction-left'>
                        <img src={teacher} alt="تدریس در سه نیک" />
                    </div>
                </div>
            </Container>
        </div>
    )
}
